export default __webpack_public_path__ + "static/media/Iphone.3b6fe9e0.jpg";